import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/black-tie': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M0 32h448v448h-448v-448zM316.5 357.2l-64.5-184 64.4-86.6h-184.9l64.5 86.6-64.5 184 92.5 88.7z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/black-tie.js
// module id = 731
// module chunks = 0